module.exports = __webpack_public_path__ + "img/ccv.2a9c690b.svg";